module.exports = __webpack_public_path__ + "img/taxaEntregaFill.663cb0bf.svg";